import React, { useEffect, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Container,
  Grid,
  TextField,
} from "@material-ui/core";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { generateBookingFilterUrl } from "../../../helpers/generateUrl";
import { connect } from "react-redux";
import {
  getCities,
} from "../store/actions";
import { useHistory } from "react-router";
// import BookingsTable from "../Tables/bookingsTable";
import Loader from "../Components/loader/index";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
      //   width: "100%",
      //   marginTop: "20px",
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
      //   padding: theme.spacing(2),
    },
    card: {
      height: "100%",
      padding: theme.spacing(1),
    },
    card_grid: {
      // wordSpacing:2,
      justifyContent: "space-between",
    },
    input: {
      padding: "1px",
    },
  })
);

interface Props {
  children: any;
  agentsList: any;
  bookingList: any;
  partnerList: any;
  getAgentList: any;
  getPartners: any;
  getAllBookings: any;
  getCities: any;
  cities: any;
  getPhlebos: any;
  phleboList: any;
  getLeadSource: any;
  lead_source: any;
  loading: Boolean;
}

const CustomerLeadFilterPage: React.FC<Props> = ({
  getAllBookings,
  bookingList,
  getCities,
  loading,
}) => {
  const classes = useStyles();

  const history = useHistory();

  const [openModal, setopenModal] = useState<boolean>(false);

  const [status, setStatus] = useState<any>([]);
  const [bookingId, setBookingId] = useState<any>("");
  const [city, setCity] = useState<any>([]);
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [booking_date, setBooking_date] = useState("");
  const [collection_date, setCollection_date] = useState("");
  const [verificationStatus, setVerificationStatus] = useState<any>([]);
  const [pickup_status, setPickup_status] = useState<any>([]);
  const [report_status, setReportStatus] = useState<any>("none");
  const [name, setName] = useState("");
  const [phlebo, setPhlebo] = useState<any>([]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileValidation, setMobileValidation] = useState<any>({
    mobileNumber: true,
  });

  const verifyMobile = (type: any) => {
    const mobileRegEx = /^[6-9]\d{9}$/;
    if (
      type === "mobile_number" &&
      !mobileRegEx.test(mobileNumber.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        mobileNumber: false,
      }));
    }
  };

  const [page, setPage] = useState(0);


  useEffect(() => {
    getCities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterBookings = () => {
    const body: any = {
      status: status.join(","),
      verificationStatus: verificationStatus.join(","),
      city: city.join(","),
      start_date,
      end_date,
      booking_date,
      collection_date,
      pickup_status: pickup_status.join(","),
      name,
      phlebo: phlebo.join(","),
      mobileNumber,
      report_status,
      bookingId,

    };
    const url = generateBookingFilterUrl(body).substring(2);
    // console.log(generateCxFilterUrl(body))
    getAllBookings(url);
    setPage(0);
  };
  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Grid
          container
          spacing={2}
          direction="row"
          style={{ alignItems: "right" }}
        >
          <Grid item xs={12} sm={8}>
            <h4 style={{ fontWeight: "bold" }}>GENOMICS RESEARCH DASHBOARD</h4>
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <h4 style={{ fontWeight: "bold" }}>BOOKING COUNT : {totalCount}</h4>
          </Grid> */}
        </Grid>
        <Grid
          container
          spacing={1}
          direction="row"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              className="input"
              name="name"
              type="text"
              label="Project Id"
              value={bookingId}
              variant="outlined"
              onChange={(e) => setBookingId(e.target.value as string)}
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              fullWidth
              className="input"
              id="name"
              label="Client Name"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              fullWidth
              id="phone"
              label=" Client Phone"
              variant="outlined"
              type="number"
              className="input"
              inputProps={{ maxLength: 10 }}
              value={mobileNumber || ""}
              onChange={(e) =>
                setMobileNumber(
                  Math.max(0, parseInt(e.target.value)).toString().slice(0, 10)
                )
              }
              onBlur={() => verifyMobile("mobile_number")}
              onFocus={() => {
                setMobileValidation((prev: any) => ({
                  ...prev,
                  mobileNumber: true,
                }));
              }}
              helperText={
                !mobileValidation.mobileNumber && "Incorrect Phone Number"
              }
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              fullWidth
              id="name"
              label="Institute Name"
              variant="outlined"
              className="input"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              fullWidth
              id="name"
              label="Application"
              className="input"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              fullWidth
              id="name"
              label="Sub Project Id"
              className="input"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={filterBookings}
            >
              Filter
            </Button>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => history.push("/dashboard/gen")}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
        <br />
        {
          loading ? (
            <Loader />
          ) : (
            bookingList.results &&
            bookingList.results.length > 0 && (
              <Box>
                <Container maxWidth={false}>
                  <Grid container spacing={2}>
                    {/* <BookingsTable
                      setopenModal={setopenModal}
                      openModal={openModal}
                      page={page}
                      setPage={setPage}
                      loading={loading}
                      getBookings={getAllBookings}
                      bookingList={bookingList}
                    /> */}
                  </Grid>
                </Container>
              </Box>
            )
          )
        }
        {
          bookingList.results && bookingList.results.length === 0 && (
            <h6 style={{ textAlign: "center" }}>No Data Found</h6>
          )
        }
      </main >
    </>
  );
};

const mapStateToProps = (state: any) => ({
  agentsList: state.GenomicsLabReducer.agentsList,
  partnerList: state.GenomicsLabReducer.partnerList,
  bookingList: state.GenomicsLabReducer.bookingList,
  cities: state.GenomicsLabReducer.cities,
  phleboList: state.GenomicsLabReducer.phleboList,
  loading: state.GenomicsLabReducer.loading,
  lead_source: state.GenomicsLabReducer.lead_source,
});

export default connect(mapStateToProps, {
  getCities,
})(CustomerLeadFilterPage);
